module.exports = __webpack_public_path__ + "static/media/app-store.f5c90ffc.png";